export enum DataHeapId {
    myTicketsQuestionsPageSubmit = 'My Tickets - Questions Page - Click - Submit',
}

export enum HeapPageArea {
    purchaseConfirmationPage = 'checkout-confirmation',
}
